import { ColorType, useTheme } from "arkh";
import { View } from "react-native";
import React, { useMemo } from "react";

export const LiveDot = (props: { color: ColorType }) => {
  const theme = useTheme();
  const style = useMemo(
    () => ({
      width: 10,
      height: 10,
      borderRadius: 5,
      backgroundColor: theme[props.color],
    }),
    [props.color, theme]
  );

  return <View style={style} />;
};
